import {
  ChangeDetectionStrategy,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../../models/BaseControlValueAccessor';

@Component({
  selector: 'irembogov-image',
  templateUrl: './irembo-image.component.html',
  styleUrls: ['./irembo-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IremboImageComponent),
      multi: true,
    },
  ],
})
export class IremboImageComponent
  extends BaseControlValueAccessor<string>
  implements ControlValueAccessor
{
  @Input() desktopWidth = '300px';
  @Input() tabletWidth = '80%';
  @Input() mobileWidth = '90%';
  @Input() objectFit: 'cover' | 'contain' | 'fill' = 'cover';
  @Input() borderRadius = '0';
  @Input() alt = '';
  @Input() defaultImage = 'assets/images/noimage.png';

  private isValidImageSource(
    value: string | null | undefined
  ): value is string {
    if (!value || value.trim() === '') {
      return false;
    }

    if (value.startsWith('data:image')) {
      const [, base64Data] = value.split(',');
      return !!base64Data && base64Data.trim() !== '' && base64Data !== 'null';
    }

    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  }

  get imageSource(): string {
    return this.isValidImageSource(this.value) ? this.value : this.defaultImage;
  }
}
